import { AppState } from "./../../../interfaces/app-state.interface";
import { Component, Input, OnInit } from "@angular/core";
import { TrInputComponent } from "../tr-input/tr-input.component";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { Store } from "@ngrx/store";

@Component({
    selector: "tr-checkbox",
    templateUrl: "./tr-checkbox.component.html",
    styleUrls: ["./tr-checkbox.component.scss"],
})
export class TrCheckboxComponent extends TrInputComponent implements OnInit {
    @Input() public checked: boolean;
    @Input() public disabled: boolean = false;
    @Input() public onToggle?: (checked: boolean) => any;

    constructor(store: Store<AppState>) {
        super(store);
    }

    public ngOnInit() {
        this.checked = this.ControlReference.value;

        this.ControlReference.valueChanges.subscribe((check) => {
            this.checked = !!check;
        });
    }

    public changeHandler(event: MatCheckboxChange) {
        const { checked } = event;

        if (this.onToggle) {
            this.onToggle(checked);
        }

        this.onChange(checked);
    }
}
